import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:9002/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de resposta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  }
);

// Cursos
export const cursosAPI = {
  listar: () => api.get('/cursos'),
  populares: () => api.get('/cursos/populares'),
  obter: (id) => api.get(`/cursos/${id}`),
  criar: (dados) => api.post('/cursos', dados),
  atualizar: (id, dados) => api.put(`/cursos/${id}`, dados),
  deletar: (id) => api.delete(`/cursos/${id}`),
  uploadCapa: (formData) => api.post('/upload/capa', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  matricular: (cursoId) => api.post(`/cursos/${cursoId}/matricular`),
  desmatricular: (cursoId) => api.delete(`/cursos/${cursoId}/desmatricular`),
  verificarMatricula: (cursoId) => api.get(`/cursos/${cursoId}/verificar-matricula`),
  meusCursos: () => api.get('/meus-cursos')
};

// Vídeos
export const videosAPI = {
  criar: (dados) => api.post('/videos', dados),
  listarPorCurso: (cursoId) => api.get(`/cursos/${cursoId}/videos`),
  obter: (id) => api.get(`/videos/${id}`),
  atualizar: (id, dados) => api.put(`/videos/${id}`, dados),
  deletar: (id) => api.delete(`/videos/${id}`),
  uploadVideo: (formData) => api.post('/upload/video', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
};

// Categorias
export const categoriasAPI = {
  listar: () => api.get('/categorias'),
  obter: (id) => api.get(`/categorias/${id}`),
  criar: (dados) => api.post('/admin/categorias', dados),
  atualizar: (id, dados) => api.put(`/admin/categorias/${id}`, dados),
  deletar: (id) => api.delete(`/admin/categorias/${id}`)
};

// Empresas
export const empresasAPI = {
  listar: () => api.get('/empresas'),
  buscarPorId: (id) => api.get(`/empresas/${id}`),
  criar: (dados) => api.post('/empresas', dados),
  atualizar: (id, dados) => api.put(`/empresas/${id}`, dados),
  deletar: (id) => api.delete(`/empresas/${id}`),
  uploadLogo: (formData) => api.post('/upload/logo-empresa', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
};

// Instrutores
export const instrutoresAPI = {
  listar: () => api.get('/instrutores'),
  obter: (id) => api.get(`/instrutores/${id}`),
  criar: (dados) => api.post('/instrutores', dados),
  atualizar: (id, dados) => api.put(`/instrutores/${id}`, dados),
  deletar: (id) => api.delete(`/instrutores/${id}`),
  uploadFoto: (formData) => api.post('/upload/instrutor-foto', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
};

// Módulos
export const modulosAPI = {
  listarPorCurso: (cursoId) => api.get(`/cursos/${cursoId}/modulos`),
  obter: (id) => api.get(`/modulos/${id}`),
  criar: (dados) => api.post('/modulos', dados),
  atualizar: (id, dados) => api.put(`/modulos/${id}`, dados),
  deletar: (id) => api.delete(`/modulos/${id}`)
};

// Progresso
export const progressoAPI = {
  atualizarProgressoVideo: (dados) => api.post('/progresso/video', dados),
  obterProgressoCurso: (cursoId, usuarioId) => api.get(`/progresso/curso/${cursoId}/usuario/${usuarioId}`),
  obterEstruturaCursoComProgresso: (cursoId, usuarioId) => api.get(`/progresso/curso/${cursoId}/usuario/${usuarioId}/estrutura`),
  obterProgressoVideo: (videoId, usuarioId) => api.get(`/progresso/video/${videoId}/usuario/${usuarioId}`),
  marcarVideoConcluido: (dados) => api.post('/progresso/video/concluir', dados)
};

// Admin (para buscar cursos populares)
export const adminAPI = {
  cursosStats: () => api.get('/admin/cursos-stats'),
  dashboard: () => api.get('/admin/dashboard')
};

export default api; 